import { useEffect } from 'react';

import find from 'lodash/find';
import { connect } from 'react-redux';
import { compose } from 'redux';

import type { TAppStoreState } from '@@/auto/store';
import withGlobals from '@@/withGlobals';

import Footer from '../Footer';
import NavBar from '../NavBar';

function LandingReferral() {
  useEffect(function onMount() {
    window.friendbuy = window.friendbuy || [];
    window.friendbuy.push([
      'widget',
      process.env.REACT_APP_FRIENDBUY_WIDGET_CODE,
    ]);
  }, []);

  return (
    <div className="ReferAFriend">
      <NavBar />
      <div
        className={`friendbuy-${process.env.REACT_APP_FRIENDBUY_WIDGET_CODE}`}
      />
      <Footer />
    </div>
  );
}

const mapStateToProps = (state: TAppStoreState) => {
  return {
    isRentersAccount: !!find(state.policies, [
      'vertical.code',
      'farmers_renters',
    ]),
  };
};

const enhance = compose(withGlobals, connect(mapStateToProps));

export default enhance(LandingReferral) as typeof LandingReferral;
